__turbopack_context__.v({
  "available": "FinanceQuoteOption-module-scss-module__X04aCq__available",
  "breakdown": "FinanceQuoteOption-module-scss-module__X04aCq__breakdown",
  "desktop": "FinanceQuoteOption-module-scss-module__X04aCq__desktop",
  "fees": "FinanceQuoteOption-module-scss-module__X04aCq__fees",
  "feesSkeleton": "FinanceQuoteOption-module-scss-module__X04aCq__feesSkeleton",
  "hide": "FinanceQuoteOption-module-scss-module__X04aCq__hide",
  "interestRate": "FinanceQuoteOption-module-scss-module__X04aCq__interestRate",
  "loading": "FinanceQuoteOption-module-scss-module__X04aCq__loading",
  "logo": "FinanceQuoteOption-module-scss-module__X04aCq__logo",
  "mobile": "FinanceQuoteOption-module-scss-module__X04aCq__mobile",
  "quote": "FinanceQuoteOption-module-scss-module__X04aCq__quote",
  "quoteAmount": "FinanceQuoteOption-module-scss-module__X04aCq__quoteAmount",
  "quoteAmountSkeleton": "FinanceQuoteOption-module-scss-module__X04aCq__quoteAmountSkeleton",
  "quoteRate": "FinanceQuoteOption-module-scss-module__X04aCq__quoteRate",
  "quoteRateSkeleton": "FinanceQuoteOption-module-scss-module__X04aCq__quoteRateSkeleton",
  "repayment": "FinanceQuoteOption-module-scss-module__X04aCq__repayment",
  "root": "FinanceQuoteOption-module-scss-module__X04aCq__root",
  "unavailable": "FinanceQuoteOption-module-scss-module__X04aCq__unavailable",
  "vwfsAdvantage": "FinanceQuoteOption-module-scss-module__X04aCq__vwfsAdvantage",
});
